import React, { useState, useEffect } from "react";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const SummaryModal = ({ show, onHide, row, refreshData }) => {
  const [selectVal, setSelectVal] = useState("New");
  const [desc, setDesc] = useState("");

  // Set default values when row changes
  useEffect(() => {
    if (row) {
      setSelectVal(row?.Status || "New");
      setDesc("");
    }
  }, [row]);

const handleSubmit = async () => {
  if (!selectVal || !row?._id) {
    return;
  }

  const followupEntry = {
    status: selectVal,
    message: desc,
    date: new Date()
  };

  try {
    const response = await fetch(`${API_URL}/contactus/updateContact/${row._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ followup: [followupEntry] })
    });

    if (!response.ok) {
      throw new Error("Failed to update contact");
    }

    if (refreshData) refreshData();  // Reload table
    onHide();
  } catch (err) {
    console.error("Error updating contact:", err);
    alert("Failed to update status");
  }
};



  return (
    <>
      {show && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full max-h-[calc(97vh_-_95px)] overflow-auto overflow-x-hidden mt-[73px]">
            <div className="flex justify-between items-center border-b p-4 fixed w-full max-w-lg py-2.5 rounded-t-[10px] bg-white">
              <h2 className="text-lg font-semibold">Summary for {row?.name || "N/A"}</h2>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={onHide}
              >
                &times;
              </button>
            </div>

            <div className="px-4 pb-4 mt-[62px]">
              <div className="my-4">
                <label className="block font-medium text-gray-700 mb-2">
                  Select Option
                </label>
                <select
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={selectVal}
                  onChange={(e) => setSelectVal(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Follow Up">Follow Up</option>
                  <option value="Contacted but no reply">Contacted but no reply</option>
                  <option value="Invalid Data">Invalid Data</option>
                  <option value="Already Booked">Already Booked</option>
                  <option value="Converted">Converted</option>
                  <option value="Pass to Vendor">Pass to Vendor</option>
                </select>
              </div>

              <div className="my-4">
                <label className="block font-medium text-gray-700 mb-2">
                  Description
                </label>
                <input
                  type="text"
                  placeholder="Enter a brief description..."
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="flex justify-end p-4 border-t">
              <button
                className="mr-3 px-6 py-2 border border-gray-400 text-gray-600 rounded hover:bg-gray-100"
                onClick={onHide}
              >
                Cancel
              </button>
              <button
                className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                onClick={handleSubmit}
                disabled={!selectVal}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SummaryModal;
